import http from "@seims/shared/src/services/HttpService";

var endpoint = `/volunteer/scientist`;
const headers = {};


const saveDemographics = (values) => {

  let formData = new FormData();

  let response;
  let { id,location } = values;

  const demographics = {
    dateOfBirth: values.dateOfBirth,
    contactNumber: values.contactNumber,
    gender: values.gender,
    disability: values.disability,
    languages: values.languages,
    location: {
      province: location.province,
      district: location.district,
      town: location.town,
    },
    race: values.race,
    title: values.title,
    volunteerDifferentLocation:values.volunteerDifferentLocation,
    preferEmail: values.preferEmail,
    preferPhone: values.preferPhone,
  };
  let metadataJson = JSON.stringify(demographics);

  formData.append("demographics",metadataJson)
  formData.append("profilePicture", values.profilePicture) 

  if (id > 0) {
    response = http.put(`${endpoint}/demographics/${id}`, formData);
  } else {
    response = http.post(`${endpoint}/demographics`, formData);
  }
  return response;
};

const saveVolunteerism = (data) => {

  const { id } = data;
  let response;

  if (id > 0) {
    response = http.put(`${endpoint}/volunteerism/${id}`, data);
  } else {
    response = http.post(`${endpoint}/volunteerism`, data);
  }
  return response;
};

const saveProfessionalExperience = (data) => {
  const { id } = data;
  let response;

  if (id > 0) {
    response = http.put(`${endpoint}/professional-experience/${id}`, data);
  } else {
    response = http.post(`${endpoint}/professional-experience`, data);
  }
  return response;
};

const getProfessionalExperience = async () => {
  const { data } = await http.get(`${endpoint}/view/professionalExperience`);
  return data;
};

const getVolunteerScientistProfile = async () => {
  const { data } = await http.get(`${endpoint}/profile`);
  return data;
};

const getDemographics = () => {
  const response = http.get(`${endpoint}/view/demographics`, {
    headers: headers,
  });
  return response;
};

const getVolunteerism = () => {
  const response = http.get(`${endpoint}/view/volunteerism`, {
    headers: headers,
  });
  return response;
};

const getVolunteerScientist = () => {
  const response = http.get(`${endpoint}/view`, {
    headers: headers,
  });
  return response;
};
const saveFinal = () => {
  const response = http.post(`${endpoint}`);
  return response;
};

export default {
  saveVolunteerism,
  saveProfessionalExperience,
  saveDemographics,
  getDemographics,
  getVolunteerism,
  getVolunteerScientist,
  saveFinal,
  getProfessionalExperience,
  getVolunteerScientistProfile,
};
